import { OrganizationSizes } from '@platform/client';
import { FormsInputDropdown } from '@platform/components';
import { Control, FieldError, FieldValues, Path, RegisterOptions } from 'react-hook-form';

type OrganizationSizeSelectionDropdownProps<FData extends FieldValues> = {
  control: Control<FData>;
  rules?: RegisterOptions<FData>;
  label: string;
  errors?: FieldError;
  name: Path<FData>;
  hintText?: string;
};

export const OrganizationSizeSelectionDropdown = <FData extends FieldValues>(
  props: OrganizationSizeSelectionDropdownProps<FData>,
) => {
  const { control, label, errors, rules, name, hintText } = props;

  const organizationSizes = OrganizationSizes.useGetOrganizationSizes().data || [];

  const orgSizeItems = organizationSizes
    .map((size) => ({
      text: size.name || '',
      textValue: size.id,
    }))
    .sort((a, b) => {
      const indexA = a.text.indexOf('-') > -1 ? a.text.indexOf('-') : a.text.indexOf('+');
      const indexB = b.text.indexOf('-') > -1 ? b.text.indexOf('-') : b.text.indexOf('+');
      const numA = Number(a.text.substring(0, indexA));
      const numB = Number(b.text.substring(0, indexB));
      return numA - numB;
    });

  return (
    <FormsInputDropdown
      control={control}
      name={name}
      rules={rules}
      label={label}
      placeholder={'Select organization size'}
      items={orgSizeItems}
      type='default'
      error={errors}
      hintText={hintText}
    />
  );
};
